import React from 'react';
import svgLogo from '../../svgs/logo.svg';

export default ()=> (
	<div className='LoginHeader'>
		<div className='LoginHeader_logo' dangerouslySetInnerHTML={{__html: svgLogo}}/>
	</div>
);